jQuery(function() {
  $('#sam-choose-file-button').on('click', function() {
    $('#sam-document-upload').click();
  });

  $('form').on('change', '#sam-document-upload', function() {
    $('#new_sam_document').submit();
  });
});